import React from 'react';

const AddEmp = () => {
    return (
        <div>
            <h1>AddEmp</h1>
        </div>
    );
};

export default AddEmp;
